import { HotelLocation } from "@/lib/redux/features/hotel/type";

export const generateAddressHotel = (location: HotelLocation, translator: any) => {
  return [
    location?.address?.address?.addressLine1,
    location?.address?.address?.addressLine2,
    translator(location?.address?.address?.stateVi, location?.address?.address?.stateEn),
    location?.address?.countryName,
  ].filter(str => !!str).join(' ')
}